
import ReactModal from "react-modal";
import { color_black, color_grey_light, color_red_active, color_red_default, color_white } from "../../constants/colors";
import { IoMdCheckmarkCircleOutline, IoMdInformationCircleOutline  } from "react-icons/io";
import { CiCircleAlert, CiCircleInfo, CiFaceFrown } from "react-icons/ci";
import { memo, useCallback } from "react";
import { OnestBoldBig, OnestSemiBoldBig, OnestNormalSmall } from "../styled/TextComponents";
import { useWindowDimensions } from "../../utils";
import { InfinitySpin } from "react-loader-spinner";

const ModalWaiting = memo(({ type, h2, isOpen, onClose, p }) => {
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            //onAfterOpen={onAfterOpen}
            style={{
                content: {
                    backgroundColor: color_white,
                    borderRadius: "16px",
                    width: screenWidth > 550 ? "400px" : screenWidth - 80,
                    height: "min-content",
                    margin: "auto",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    inset: screenWidth > 460 ? "40px" : `calc(50vw - ${screenWidth - 80 / 2}px)`
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "scroll",
                    zIndex: 1000,
                },

            }}
        >
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                {type === "success" && 
                    <IoMdCheckmarkCircleOutline size={28}/>
                }
                {type === "alert" && 
                    <IoMdInformationCircleOutline size={28}/>
                }
                {type === "error" &&
                    <CiFaceFrown  size={28}/>
                }
                <OnestSemiBoldBig style={{ fontSize: type !== "alert" ? "24px" : "14px" , textAlign: "center", color: color_black, marginTop: 8 }}>{h2}</OnestSemiBoldBig>
                <InfinitySpin width={200} color={color_red_default} />
                {p && <OnestNormalSmall style={{textAlign: 'center', padding: '0 40px', maxWidth: '350px'}}>{p}</OnestNormalSmall>}
                
            </div>

        </ReactModal>
    )
})

export default ModalWaiting